import React from 'react';
import { Redirect } from 'react-router-dom'; 
import Testimonial from '../components/Testimonial/';



 

const Page = ({   history, isAuthenticated, match }) => {
    if (!isAuthenticated) return <Redirect to="/login" />
 
    return (
        <div className="Testimonial">  
             <Testimonial history={history} match={ match }   />
        </div>
    );
}

 


export default Page;